import Dexie from 'dexie';

const DB_NAME = 'spenderlyDB_mvp';

const ALL_STORES = {
    transactions: 'id, user_id, date, amount, raw_merchant, merchant_key, category, subcategory, source, confidence',
    user_overrides: '[user_id+merchant_key]',
    merchant_registry: 'merchant_key, category, subcategory, vote_count, confidence',
    fixed_expenses: '++id, type',
    budgets: 'category',
    goals: '++id',
    waitlist: '++id, email, timestamp'
};

export const db = new Dexie(DB_NAME);

db.version(2).stores(ALL_STORES);

// Check if the new tables really exist, if not nuke and recreate
db.on('ready', async () => {
    try {
        // Quick test write/delete to verify fixed_expenses table works
        const testId = await db.fixed_expenses.add({ name: '__test__', amount: 0, type: 'other', frequency: 'monthly' });
        await db.fixed_expenses.delete(testId);
    } catch (e) {
        console.warn('Table verification failed, resetting DB:', e.message);
        db.close();
        await Dexie.delete(DB_NAME);
        // Reopen will rebuild with v1 schema
        await db.open();
    }
});
